export default __webpack_public_path__ + "static/logo2-34f15b7c1f281fa0a0142d86c7776c83.webp";